import React, { useState } from 'react';
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Slider,
  Button,
  Stack,
} from '@mui/material';
import { Star } from 'lucide-react';
import { GENERAL_AMENITIES, RECREATIONAL_AMENITIES, DINING_AMENITIES, SERVICE_AMENITIES } from '../types/property';

export function FilterSidebar({ filters, onFilterChange }) {
  const propertyTypes = ['hotel', 'homestay', 'resort', 'farm stay', 'villa', 'cottage', 'hostel', 'dormitory'];
  const amenitiesList = [
  ...GENERAL_AMENITIES,
  ...RECREATIONAL_AMENITIES,
  ...DINING_AMENITIES,
  ...SERVICE_AMENITIES,
];

const [showAllAmenities, setShowAllAmenities] = useState(false);

const visibleAmenities = showAllAmenities
  ? amenitiesList
  : amenitiesList.slice(0, 8); // show first 6 only

const handlePropertyTypeChange = (type) => {
  const newTypes = filters.propertyTypes.includes(type)
    ? filters.propertyTypes.filter(t => t !== type)
    : [...filters.propertyTypes, type];
  onFilterChange({ ...filters, propertyTypes: newTypes });
};


  const handleAmenityChange = (amenity, checked) => {
    const updated = checked
      ? [...filters.amenities, amenity]
      : filters.amenities.filter(a => a !== amenity);
    onFilterChange({ ...filters, amenities: updated });
  };

  const handlePriceChange = (event, newValue) => {
    onFilterChange({ ...filters, priceRange: newValue });
  };

  const handleRatingChange = (rating) => {
    onFilterChange({ ...filters, ratings: filters.ratings === rating ? 0 : rating });
  };

  const clearFilters = () => {
    onFilterChange({
      propertyTypes: [],
      priceRange: [0, 100000],
      amenities: [],
      ratings: 0,
    });
  };

  return (
<Box
  sx={{
    bgcolor: 'background.paper',
    borderRadius: 2,
    p: 3,
    boxShadow: 1,
    position: { xs: 'relative', md: 'sticky' }, 
    top: { md: 96 }, // only desktop
    height: { xs: '100%', md: 'fit-content' }, // important for drawer
    overflowY: { xs: 'auto', md: 'visible' }, // scroll inside mobile drawer
  }}
>

      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h6">Filters</Typography>
        <Button variant="text" size="small" onClick={clearFilters}>
          Clear all
        </Button>
      </Stack>

      {/* Property Type */}
     {/* Property Type - FULLY FIXED */}
<Box mb={4}>
  <Typography variant="subtitle1" mb={1}>Property Type</Typography>
  <Stack spacing={1}>
    {propertyTypes.map((type) => (
      <FormControlLabel
        key={type}
        control={
          <Checkbox
            checked={filters.propertyTypes.includes(type)}
            onChange={e => handlePropertyTypeChange(type)} 
          />
        }
        label={type}
      />
    ))}
  </Stack>
</Box>


      {/* Price Range */}
      <Box mb={4}>
        <Typography variant="subtitle1" mb={1}>Price Range</Typography>
 <Slider
  value={filters.priceRange}
  onChange={handlePriceChange}
  min={0}
  max={100000}
  step={500}
  valueLabelDisplay="auto"
/>

        <Stack direction="row" justifyContent="space-between" color="text.secondary" fontSize="0.875rem">
          <span>₹{filters.priceRange[0].toLocaleString('en-IN')}</span>
          <span>₹{filters.priceRange[1].toLocaleString('en-IN')}</span>
        </Stack>
      </Box>

    

      {/* Amenities */}
     {/* Amenities */}
<Box mb={4}>
  <Typography variant="subtitle1" mb={1}>Amenities</Typography>

  <Stack spacing={1}>
    {visibleAmenities.map((amenity) => (
      <FormControlLabel
        key={amenity}
        control={
          <Checkbox
            checked={filters.amenities.includes(amenity)}
            onChange={e => handleAmenityChange(amenity, e.target.checked)}
          />
        }
        label={amenity}
      />
    ))}
  </Stack>

  {amenitiesList.length > 8 && (
    <Button
      size="small"
      onClick={() => setShowAllAmenities(!showAllAmenities)}
      sx={{ mt: 1, textTransform: 'none' }}
    >
      {showAllAmenities ? 'Show Less' : '+ More'}
    </Button>
  )}
</Box>

        {/* Rating */}
      <Box mb={4}>
        <Typography variant="subtitle1" mb={1}>Rating</Typography>
        <Stack spacing={1}>
          {[5, 4, 3, 2].map((rating) => (
            <Button
              key={rating}
              variant={filters.ratings === rating ? 'contained' : 'outlined'}
              startIcon={<Star size={16} fill="#fbbf24" color="#fbbf24" />}
              onClick={() => handleRatingChange(rating)}
              fullWidth
              size="small"
              sx={{ justifyContent: 'flex-start', textTransform: 'none' }}
            >
              {rating}+ stars
            </Button>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
